import { render, staticRenderFns } from "./ProfilDoctor.vue?vue&type=template&id=6a2d2724&scoped=true&"
import script from "./ProfilDoctor.vue?vue&type=script&lang=js&"
export * from "./ProfilDoctor.vue?vue&type=script&lang=js&"
import style0 from "./ProfilDoctor.vue?vue&type=style&index=0&id=6a2d2724&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2d2724",
  null
  
)

export default component.exports